import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect, } from '@ngrx/effects';
import { map, switchMap, tap } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { authLogin, authLoginSuccess, getUser, getUserSuccess } from '../actions/auth.actions';
import { ILoginResponse, IUserResponse } from '../../interfaces/auth.interface';
import { AuthenticationService } from 'src/app/services/authentication.service';


@Injectable()
export class AuthEffects {

  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(authLogin),
      switchMap(payload =>
        this.apiService.login(payload.login).pipe(
          tap((response: ILoginResponse) => this.authenticationService.finishLogin(response.token)),
          map((response: ILoginResponse) => authLoginSuccess({ response }))
        )
      )
    )
  );

  getUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getUser),
      switchMap(() => {
        const currentToken = this.authenticationService.currentTokenValue;
        return this.apiService.getUser(currentToken).pipe(
          map((response: IUserResponse) => getUserSuccess({ response }))
        )
      }
      )
    )
  );

  constructor(
    private apiService: ApiService,
    private actions$: Actions,
    private authenticationService: AuthenticationService,
    private store: Store<IAppState>
  ) { }
}
